import storage from "./storage";
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace SponsorStorageService
 */
var SponsorStorageService = function () {
    "use strict";

    var STORAGE_KEY = storage.metadata.SPONSOR;

    // ---------------------------------------------
    //
    //            Define public methods
    //
    // ---------------------------------------------
    var publicMethods = {
        clearSponsor: function(){
            publicMethods.setSponsor(null);
        },
        getSponsor: function(){
            return storage.getItem(STORAGE_KEY);
        },
        setSponsor: function(sponsor){
            if (sponsor == null || typeof (sponsor) == 'undefined') {
                storage.removeItem(STORAGE_KEY);
            } else {
                storage.setItem(STORAGE_KEY, sponsor);
            }
        }
    };

    return publicMethods;
}();

export default SponsorStorageService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/sponsorStorageService.js
// module id = 182
// module chunks = 0